module.exports = __webpack_public_path__ + "static/media/dromoland.64c33648.png";